<div class="divider">
  <div class="divider__line"></div>
</div>
